import { Button, TableCell, TableRow } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { downloadDocX } from "../../helpers/download-docx"

export function ExportScheduleRow({ schedule }) {
    return (
        <TableRow key={schedule?.id} data-cy={`scheduleTableRow-scheduleId-${schedule?.id}`}>
            <TableCell data-cy="scheduleIdCell">{schedule?.id}</TableCell>
            <TableCell data-cy="scheduleTitleCell">{schedule?.title}</TableCell>
            <TableCell data-cy="scheduleCodeCell">{schedule?.code}</TableCell>
            <TableCell data-cy="scheduleVersionCell">{schedule?.version}</TableCell>
            <TableCell data-cy="scheduleDownloadCell">
                <Button startIcon={<Iconify icon="mdi:file-download" />} onClick={() => doDownload(schedule)}>
                    Download
                </Button>
            </TableCell>
        </TableRow>
    )

    async function doDownload(data) {
        downloadDocX(data)
    }
}
